import React from 'react';
import styles from './Calculator.module.less';

interface KeysWindowProps {
  handleButton: (value: string) => void;
}

const KeysWindow: React.FC<KeysWindowProps> = ({ handleButton }) => {
  const sciKeys = ['sin', 'cos', 'ln', 'log', 'tan', 'π', 'e', '^', '!', '√'];

  const basicKeys = [
    'AC',
    '(',
    ')',
    '/',
    '7',
    '8',
    '9',
    '*',
    '4',
    '5',
    '6',
    '-',
    '1',
    '2',
    '3',
    '+',
    'DEL',
    '0',
    '.',
    '=',
  ];

  return (
    <div className={styles.keysWindow}>
      <div className={styles.keys_scientific}>
        {sciKeys.map((item, index) => (
          <button key={index} onClick={() => handleButton(item)}>
            {item}
          </button>
        ))}
      </div>

      <div className={styles.line}></div>

      <div className={styles.keys_basic}>
        {basicKeys.map((item, index) => (
          <button
            key={index}
            className={`${item >= '0' && item <= '9' ? styles.number : ''} ${item === '=' ? styles.equal : ''}`}
            onClick={() => handleButton(item)}
          >
            {item}
          </button>
        ))}
      </div>
    </div>
  );
};

export default KeysWindow;
